import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const SearchDataSetSchema = withDefaults({
  // No 'search-' prefix -- see search-index-definition.schema.ts's identical comment. Matches
  // Api::V2::Admin::DataSetResource's own bare wire type ('data-sets', normalized singular).
  type: 'data-set',
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'indexName',
    },
    {
      kind: 'attribute',
      name: 'discriminatorField',
    },
    {
      kind: 'attribute',
      name: 'anchorKeys',
    },
    {
      kind: 'attribute',
      name: 'settings',
    },
    {
      kind: 'attribute',
      name: 'enabled',
    },
    {
      kind: 'attribute',
      name: 'active',
    },
    {
      kind: 'attribute',
      name: 'version',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'hasMany',
      name: 'dataSetMembers',
      type: 'data-set-member',
      options: {
        async: false,
        inverse: 'dataSet',
      },
    },
  ],
});

export default SearchDataSetSchema;
